/* eslint-disable max-len */

export const RecentlyVisitedLocationsDefaultThumbnail = () => {
  return (
    <svg
      width="33"
      height="34"
      viewBox="0 0 33 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: '33px', height: '34px' }}
      data-testid="recently-visited-location-default-thumbnail"
    >
      <path
        opacity="0.5"
        d="M5.99569 5C5.99569 9.59072 1 9.68446 1 9.68446V9.69274C1 9.69274 5.99569 9.78648 5.99569 14.3772L6.00431 14.3855C6.00431 9.79476 11 9.70102 11 9.70102V9.69274C11 9.69274 6.00431 9.599 6.00431 5.00828L5.99569 5Z"
        stroke="#100C0D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.5"
        d="M28 9.34264C30.2139 9.34264 32 7.47511 32 5.17132C32 2.86754 30.2139 1 28 1C25.7861 1 24 2.86754 24 5.17132C24 7.47511 25.7955 9.34264 28 9.34264Z"
        stroke="#100C0D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.5"
        d="M18.5 33C22.651 33 26 29.6422 26 25.5C26 21.3578 22.651 18 18.5 18C14.349 18 11 21.3578 11 25.5C11 29.6422 14.3666 33 18.5 33Z"
        stroke="#100C0D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
